import React, { useContext } from "react";
import './GeneratorPanelsContainer.css';
import { ActiveEditorContext } from "../../context/ActiveEditorContext";
import QuizGeneratorPanel from "./panels/QuizGeneratorPanel";
import ABCDGeneratorPanel from "./panels/ABCDGeneratorPanel";
import OpenQuestionsGeneratorPanel from "./panels/OpenQuestionsGeneratorPanel";
import WordDefinitionGeneratorPanel from "./panels/WordDefinitionGeneratorPanel";
import WordTranslationGeneratorPanel from "./panels/WordTranslationGeneratorPanel";
import FillInTheGapsGeneratorPanel from "./panels/FillInTheGapsGeneratorPanel";
import TrueFalseGeneratorPanel from "./panels/TrueFalseGeneratorPanel";
import WarmUpDiscussionGeneratorPanel from "./panels/WarmUpDiscussionGeneratorPanel";
import CreateDialogueGeneratorPanel from "./panels/CreateDialogueGeneratorPanel";
import EssentialVocabularyGeneratorPanel from "./panels/EssentialVocabularyGeneratorPanel";
import LeadInActivitiesGeneratorPanel from "./panels/LeadInActivitiesGeneratorPanel";
import FourOpinionsGeneratorPanel from "./panels/FourOpinionsGeneratorPanel";
import CommunicativeSituationsGeneratorPanel from "./panels/CommunicativeSituationsGeneratorPanel";
import ProsConsGeneratorPanel from "./panels/ProsConsGeneratorPanel";
import MatchingHalvesGeneratorPanel from "./panels/MatchingHalvesGeneratorPanel";
import ErrorCorrectionGeneratorPanel from "./panels/ErrorCorrectionGeneratorPanel";
import GrammarRulesGeneratorPanel from "./panels/GrammarRulesGeneratorPanel";
import JumbledSentenceGeneratorPanel from "./panels/JumbledSentenceGeneratorPanel";
import MultipleChoiceGeneratorPanel from "./panels/MultipleChoiceGeneratorPanel";
import { useQuizGeneratorLogic } from "../../hooks/useQuizGeneratorLogic";
import { useABCDGeneratorLogic } from "../../hooks/useABCDGeneratorLogic";
import { useOpenQuestionsGeneratorLogic } from "../../hooks/useOpenQuestionsGeneratorLogic";
import { useWordDefinitionGeneratorLogic } from "../../hooks/useWordDefinitionGeneratorLogic";
import { useWordTranslationGeneratorLogic } from "../../hooks/useWordTranslationGeneratorLogic";
import { useFillInTheGapsGeneratorLogic } from "../../hooks/useFillInTheGapsGeneratorLogic";
import { useTrueFalseGeneratorLogic } from "../../hooks/useTrueFalseGeneratorLogic";
import { useWarmUpDiscussionGeneratorLogic } from "../../hooks/useWarmUpDiscussionGeneratorLogic";
import { useCreateDialogueGeneratorLogic } from "../../hooks/useCreateDialogueGeneratorLogic";
import { useEssentialVocabularyGeneratorLogic } from "../../hooks/useEssentialVocabularyGeneratorLogic";
import { useLeadInActivitiesGeneratorLogic } from "../../hooks/useLeadInActivitiesGeneratorLogic";
import { useFourOpinionsGeneratorLogic } from "../../hooks/useFourOpinionsGeneratorLogic";
import { useCommunicativeSituationsGeneratorLogic } from "../../hooks/useCommunicativeSituationsGeneratorLogic";
import { useProsConsGeneratorLogic } from "../../hooks/useProsConsGeneratorLogic";
import { useMatchingHalvesGeneratorLogic } from "../../hooks/useMatchingHalvesGeneratorLogic";
import { useErrorCorrectionGeneratorLogic } from "../../hooks/useErrorCorrectionGeneratorLogic";
import { useGrammarRulesGeneratorLogic } from "../../hooks/useGrammarRulesGeneratorLogic";
import { useJumbledSentenceGeneratorLogic } from "../../hooks/useJumbledSentenceGeneratorLogic";
import { useMultipleChoiceGeneratorLogic } from "../../hooks/useMultipleChoiceGeneratorLogic";

export default function GeneratorPanelsContainer({
  showQuizGenerator, setShowQuizGenerator, quizInput, setQuizInput, quizLoading, setQuizLoading,
  quizLevel, setQuizLevel, quizCount, setQuizCount, generatedQuiz, setGeneratedQuiz, quizType, setQuizType,
  showABCDGenerator, setShowABCDGenerator, abcdInput, setABCDInput, abcdLevel, setABCDLevel,
  abcdLoading, setABCDLoading, generatedABCD, setGeneratedABCD, abcdQuestionCount, setABCDQuestionCount,
  showOpenQuestionsGenerator, setShowOpenQuestionsGenerator, openQuestionsInput, setOpenQuestionsInput,
  openQuestionsLevel, setOpenQuestionsLevel, openQuestionsLoading, setOpenQuestionsLoading,
  generatedOpenQuestions, setGeneratedOpenQuestions, openQuestionsCount, setOpenQuestionsCount,
  showWordDefinitionGenerator, setShowWordDefinitionGenerator, wordDefinitionInput, setWordDefinitionInput,
  wordDefinitionLevel, setWordDefinitionLevel, wordDefinitionLoading, setWordDefinitionLoading,
  generatedWordDefinitions, setGeneratedWordDefinitions,
  showWordTranslationGenerator, setShowWordTranslationGenerator, wordTranslationInput, setWordTranslationInput,
  wordTranslationTargetLanguage, setWordTranslationTargetLanguage, wordTranslationLoading, setWordTranslationLoading,
  generatedWordTranslations, setGeneratedWordTranslations,
  showFillInTheGapsGenerator, setShowFillInTheGapsGenerator, fillInTheGapsInput, setFillInTheGapsInput,
  fillInTheGapsLevel, setFillInTheGapsLevel, fillInTheGapsLoading, setFillInTheGapsLoading,
  generatedFillInTheGaps, setGeneratedFillInTheGaps,
  fillInTheGapsMode, setFillInTheGapsMode, fillInTheGapsCustomText, setFillInTheGapsCustomText,
  showTrueFalseGenerator, setShowTrueFalseGenerator, trueFalseInput, setTrueFalseInput,
  trueFalseLevel, setTrueFalseLevel, trueFalseCount, setTrueFalseCount, trueFalseLoading, setTrueFalseLoading,
  generatedTrueFalse, setGeneratedTrueFalse,
  showWarmUpDiscussionGenerator, setShowWarmUpDiscussionGenerator, warmUpDiscussionInput, setWarmUpDiscussionInput,
  warmUpDiscussionLevel, setWarmUpDiscussionLevel, warmUpDiscussionCount, setWarmUpDiscussionCount,
  warmUpDiscussionLoading, setWarmUpDiscussionLoading, generatedWarmUpDiscussion, setGeneratedWarmUpDiscussion,
  showCreateDialogueGenerator, setShowCreateDialogueGenerator, createDialogueInput, setCreateDialogueInput,
  createDialogueLevel, setCreateDialogueLevel, createDialogueSpeakers, setCreateDialogueSpeakers,
  createDialogueLoading, setCreateDialogueLoading, generatedCreateDialogue, setGeneratedCreateDialogue,
  showEssentialVocabularyGenerator, setShowEssentialVocabularyGenerator, essentialVocabularyMode, setEssentialVocabularyMode,
  essentialVocabularyInput, setEssentialVocabularyInput, essentialVocabularyLevel, setEssentialVocabularyLevel,
  essentialVocabularyPartOfSpeech, setEssentialVocabularyPartOfSpeech,
  essentialVocabularyTranslationLanguage, setEssentialVocabularyTranslationLanguage,
  essentialVocabularyLoading, setEssentialVocabularyLoading, generatedEssentialVocabulary, setGeneratedEssentialVocabulary,
  showLeadInActivitiesGenerator, setShowLeadInActivitiesGenerator, leadInActivitiesInput, setLeadInActivitiesInput,
  leadInActivitiesLevel, setLeadInActivitiesLevel, leadInActivitiesLoading, setLeadInActivitiesLoading,
  generatedLeadInActivities, setGeneratedLeadInActivities,
  showFourOpinionsGenerator, setShowFourOpinionsGenerator, fourOpinionsInput, setFourOpinionsInput,
  fourOpinionsLevel, setFourOpinionsLevel, fourOpinionsCount, setFourOpinionsCount,
  fourOpinionsLoading, setFourOpinionsLoading, generatedFourOpinions, setGeneratedFourOpinions,
  showCommunicativeSituationsGenerator, setShowCommunicativeSituationsGenerator,
  communicativeSituationsVocab, setCommunicativeSituationsVocab,
  communicativeSituationsTopic, setCommunicativeSituationsTopic,
  communicativeSituationsLevel, setCommunicativeSituationsLevel,
  communicativeSituationsLoading, setCommunicativeSituationsLoading,
  generatedCommunicativeSituations, setGeneratedCommunicativeSituations,
  showMatchingHalvesGenerator, setShowMatchingHalvesGenerator, matchingHalvesInput, setMatchingHalvesInput,
  matchingHalvesLevel, setMatchingHalvesLevel, matchingHalvesMode, setMatchingHalvesMode,
  matchingHalvesLoading, setMatchingHalvesLoading, generatedMatchingHalves, setGeneratedMatchingHalves,
  showErrorCorrectionGenerator, setShowErrorCorrectionGenerator, errorCorrectionInput, setErrorCorrectionInput,
  errorCorrectionLevel, setErrorCorrectionLevel, errorCorrectionSentenceCount, setErrorCorrectionSentenceCount,
  errorCorrectionLoading, setErrorCorrectionLoading, generatedErrorCorrection, setGeneratedErrorCorrection,
  showGrammarRulesGenerator, setShowGrammarRulesGenerator, grammarRulesInput, setGrammarRulesInput,
  grammarRulesLevel, setGrammarRulesLevel, grammarRulesLanguage, setGrammarRulesLanguage,
  grammarRulesLoading, setGrammarRulesLoading, generatedGrammarRules, setGeneratedGrammarRules,
  showProsConsGenerator, setShowProsConsGenerator, prosConsInput, setProsConsInput,
  prosConsLevel, setProsConsLevel, prosConsPairs, setProsConsPairs,
  prosConsLoading, setProsConsLoading, generatedProsCons, setGeneratedProsCons,
  showJumbledSentenceGenerator, setShowJumbledSentenceGenerator,
  jumbledSentenceInput, setJumbledSentenceInput,
  jumbledSentenceLevel, setJumbledSentenceLevel,
  jumbledSentenceCount, setJumbledSentenceCount,
  jumbledSentenceLoading, setJumbledSentenceLoading,
  generatedJumbledSentence, setGeneratedJumbledSentence,
  jumbledSentenceMode, setJumbledSentenceMode,
  showMultipleChoiceGenerator, setShowMultipleChoiceGenerator,
  multipleChoiceInput, setMultipleChoiceInput,
  multipleChoiceLevel, setMultipleChoiceLevel,
  multipleChoiceMode, setMultipleChoiceMode,
  multipleChoiceCount, setMultipleChoiceCount,
  multipleChoiceOptionCount, setMultipleChoiceOptionCount,
  multipleChoiceLoading, setMultipleChoiceLoading,
  generatedMultipleChoice, setGeneratedMultipleChoice,
  showTemplates, setShowTemplates, templateTagFilter, setTemplateTagFilter,
  selectedTemplate, setSelectedTemplate, exerciseResult, setExerciseResult,
  showAskMe, setShowAskMe, showSmartLesson,
  onInsertToBoard, currentTab,
  editor,
  handleTemplateSelect, TEMPLATES,
}) {
  const { activeEditor } = useContext(ActiveEditorContext);
  const handleScrollInDropdown = (e) => { e.stopPropagation(); };


  const { handleQuizGenerate, handleQuizInsert, handleQuizCancel } = useQuizGeneratorLogic({
    quizInput, setQuizInput, quizType, setQuizType, quizLevel, quizCount,
    setQuizLoading, generatedQuiz, setGeneratedQuiz,
    currentTab, onInsertToBoard, activeEditor,
    setShowQuizGenerator, setSelectedTemplate,
  });

  const { handleABCDGenerate, handleABCDInsert, handleABCDCancel } = useABCDGeneratorLogic({
    abcdInput, setABCDInput, abcdLevel, abcdQuestionCount,
    setABCDLoading, setGeneratedABCD, generatedABCD,
    currentTab, onInsertToBoard, activeEditor,
    setShowABCDGenerator, setSelectedTemplate,
  });

  const { handleOpenQuestionsGenerate, handleOpenQuestionsInsert, handleOpenQuestionsCancel } = useOpenQuestionsGeneratorLogic({
    openQuestionsInput, setOpenQuestionsInput, openQuestionsLevel, openQuestionsCount,
    setOpenQuestionsLoading, generatedOpenQuestions, setGeneratedOpenQuestions,
    currentTab, onInsertToBoard, activeEditor,
    setShowOpenQuestionsGenerator, setSelectedTemplate,
  });


  const { handleWordDefinitionGenerate, handleWordDefinitionInsert, handleWordDefinitionCancel } = useWordDefinitionGeneratorLogic({
    wordDefinitionInput, setWordDefinitionInput, wordDefinitionLevel,
    setWordDefinitionLoading, generatedWordDefinitions, setGeneratedWordDefinitions,
    currentTab, activeEditor, onInsertToBoard,
    setShowWordDefinitionGenerator, setSelectedTemplate,
  });


  const { handleWordTranslationGenerate, handleWordTranslationInsert, handleWordTranslationCancel } = useWordTranslationGeneratorLogic({
    wordTranslationInput, setWordTranslationInput, wordTranslationTargetLanguage,
    setWordTranslationLoading, generatedWordTranslations, setGeneratedWordTranslations,
    currentTab, activeEditor, onInsertToBoard,
    setShowWordTranslationGenerator, setSelectedTemplate,
  });


  const {
    fitgTextareaRef, handleMarkGapInText,
    handleFillInTheGapsGenerate, handleFillInTheGapsInsertCustom,
    handleFillInTheGapsInsert, handleFillInTheGapsCancel,
  } = useFillInTheGapsGeneratorLogic({
    fillInTheGapsInput, setFillInTheGapsInput, fillInTheGapsLevel,
    setFillInTheGapsLoading, generatedFillInTheGaps, setGeneratedFillInTheGaps,
    fillInTheGapsCustomText, setFillInTheGapsCustomText, setFillInTheGapsMode,
    currentTab, activeEditor, onInsertToBoard,
    setShowFillInTheGapsGenerator, setSelectedTemplate,
  });


  const { handleTrueFalseGenerate, handleTrueFalseInsert, handleTrueFalseCancel } = useTrueFalseGeneratorLogic({
    trueFalseInput, setTrueFalseInput, trueFalseLevel, trueFalseCount, setTrueFalseCount,
    setTrueFalseLoading, generatedTrueFalse, setGeneratedTrueFalse,
    currentTab, activeEditor, onInsertToBoard,
    setShowTrueFalseGenerator, setSelectedTemplate,
  });


  const { handleWarmUpDiscussionGenerate, handleWarmUpDiscussionInsert, handleWarmUpDiscussionCancel } = useWarmUpDiscussionGeneratorLogic({
    warmUpDiscussionInput, setWarmUpDiscussionInput, warmUpDiscussionLevel,
    warmUpDiscussionCount, setWarmUpDiscussionCount,
    setWarmUpDiscussionLoading, generatedWarmUpDiscussion, setGeneratedWarmUpDiscussion,
    currentTab, onInsertToBoard, activeEditor,
    setShowWarmUpDiscussionGenerator, setSelectedTemplate,
  });


  const { handleCreateDialogueGenerate, handleCreateDialogueInsert, handleCreateDialogueCancel } = useCreateDialogueGeneratorLogic({
    createDialogueInput, setCreateDialogueInput, createDialogueLevel, createDialogueSpeakers,
    setCreateDialogueLoading, generatedCreateDialogue, setGeneratedCreateDialogue,
    editor, activeEditor, currentTab, onInsertToBoard,
    setShowCreateDialogueGenerator, setSelectedTemplate,
  });


  const { handleEssentialVocabularyGenerate, handleEssentialVocabularyInsert, handleEssentialVocabularyCancel } = useEssentialVocabularyGeneratorLogic({
    essentialVocabularyInput, setEssentialVocabularyInput, essentialVocabularyMode, setEssentialVocabularyMode,
    essentialVocabularyLevel, essentialVocabularyPartOfSpeech, setEssentialVocabularyPartOfSpeech,
    essentialVocabularyTranslationLanguage, setEssentialVocabularyTranslationLanguage,
    setEssentialVocabularyLoading, generatedEssentialVocabulary, setGeneratedEssentialVocabulary,
    currentTab, onInsertToBoard, activeEditor,
    setShowEssentialVocabularyGenerator, setSelectedTemplate,
  });


  const { handleLeadInActivitiesGenerate, handleLeadInActivitiesInsert, handleLeadInActivitiesCancel } = useLeadInActivitiesGeneratorLogic({
    leadInActivitiesInput, setLeadInActivitiesInput, leadInActivitiesLevel,
    setLeadInActivitiesLoading, generatedLeadInActivities, setGeneratedLeadInActivities,
    currentTab, onInsertToBoard, activeEditor,
    setShowLeadInActivitiesGenerator, setSelectedTemplate,
  });


  const { handleFourOpinionsGenerate, handleFourOpinionsInsert, handleFourOpinionsCancel } = useFourOpinionsGeneratorLogic({
    fourOpinionsInput, setFourOpinionsInput, fourOpinionsLevel, fourOpinionsCount, setFourOpinionsCount,
    setFourOpinionsLoading, generatedFourOpinions, setGeneratedFourOpinions,
    currentTab, onInsertToBoard, editor, activeEditor,
    setShowFourOpinionsGenerator, setSelectedTemplate,
  });


  const { handleCommunicativeSituationsGenerate, handleCommunicativeSituationsInsert, handleCommunicativeSituationsCancel } = useCommunicativeSituationsGeneratorLogic({
    communicativeSituationsVocab, setCommunicativeSituationsVocab,
    communicativeSituationsTopic, setCommunicativeSituationsTopic,
    communicativeSituationsLevel, setCommunicativeSituationsLoading,
    generatedCommunicativeSituations, setGeneratedCommunicativeSituations,
    currentTab, onInsertToBoard, activeEditor,
    setShowCommunicativeSituationsGenerator, setSelectedTemplate,
  });


  // Pros/Cons generator states
  const { handleProsConsGenerate, handleProsConsInsert } = useProsConsGeneratorLogic({
    prosConsInput, setProsConsInput, prosConsLevel, prosConsPairs,
    setProsConsLoading, generatedProsCons, setGeneratedProsCons,
    currentTab, onInsertToBoard, activeEditor,
    setShowProsConsGenerator, setSelectedTemplate,
  });


  // Отдельная функция для генерации из слов
  const { handleMatchingHalvesGenerate, handleMatchingHalvesInsert, handleMatchingHalvesCancel } = useMatchingHalvesGeneratorLogic({
    matchingHalvesInput, setMatchingHalvesInput, matchingHalvesLevel,
    matchingHalvesMode, setMatchingHalvesMode,
    setMatchingHalvesLoading, generatedMatchingHalves, setGeneratedMatchingHalves,
    currentTab, activeEditor, onInsertToBoard,
    setShowMatchingHalvesGenerator, setSelectedTemplate,
  });


  const { handleErrorCorrectionGenerate, handleErrorCorrectionInsert, handleErrorCorrectionCancel } = useErrorCorrectionGeneratorLogic({
    errorCorrectionInput, setErrorCorrectionInput, errorCorrectionLevel,
    errorCorrectionSentenceCount, setErrorCorrectionSentenceCount,
    setErrorCorrectionLoading, generatedErrorCorrection, setGeneratedErrorCorrection,
    currentTab, onInsertToBoard, activeEditor,
    setShowErrorCorrectionGenerator, setSelectedTemplate,
  });

  // Grammar Rules handlers
  const { handleGrammarRulesGenerate, handleGrammarRulesInsert, handleGrammarRulesCancel } = useGrammarRulesGeneratorLogic({
    grammarRulesInput, setGrammarRulesInput, grammarRulesLevel, grammarRulesLanguage,
    setGrammarRulesLoading, generatedGrammarRules, setGeneratedGrammarRules,
    currentTab, onInsertToBoard, activeEditor,
    setShowGrammarRulesGenerator, setSelectedTemplate,
  });


  const { handleJumbledSentenceGenerate, handleJumbledSentenceInsert, handleJumbledSentenceCancel } = useJumbledSentenceGeneratorLogic({
    jumbledSentenceInput, setJumbledSentenceInput, jumbledSentenceMode, setJumbledSentenceMode,
    jumbledSentenceLevel, jumbledSentenceCount,
    setJumbledSentenceLoading, generatedJumbledSentence, setGeneratedJumbledSentence,
    currentTab, onInsertToBoard, activeEditor,
    setShowJumbledSentenceGenerator, setSelectedTemplate,
  });


  const { handleMultipleChoiceGenerate, handleMultipleChoiceInsert, handleMultipleChoiceCancel } = useMultipleChoiceGeneratorLogic({
    multipleChoiceInput, setMultipleChoiceInput, multipleChoiceMode, setMultipleChoiceMode,
    multipleChoiceLevel, multipleChoiceOptionCount, multipleChoiceCount,
    setMultipleChoiceLoading, generatedMultipleChoice, setGeneratedMultipleChoice,
    currentTab, onInsertToBoard, activeEditor,
    setShowMultipleChoiceGenerator, setSelectedTemplate,
  });


  return (
    <>
          <QuizGeneratorPanel
            showQuizGenerator={showQuizGenerator}
            generatedQuiz={generatedQuiz}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            showMatchingHalvesGenerator={showMatchingHalvesGenerator}
            showErrorCorrectionGenerator={showErrorCorrectionGenerator}
            showGrammarRulesGenerator={showGrammarRulesGenerator}
            quizType={quizType}
            setQuizType={setQuizType}
            quizLevel={quizLevel}
            setQuizLevel={setQuizLevel}
            quizCount={quizCount}
            setQuizCount={setQuizCount}
            quizInput={quizInput}
            setQuizInput={setQuizInput}
            quizLoading={quizLoading}
            handleQuizGenerate={handleQuizGenerate}
            handleQuizInsert={handleQuizInsert}
            handleQuizCancel={handleQuizCancel}
          />

          <ABCDGeneratorPanel
            showABCDGenerator={showABCDGenerator}
            generatedABCD={generatedABCD}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            showMatchingHalvesGenerator={showMatchingHalvesGenerator}
            showErrorCorrectionGenerator={showErrorCorrectionGenerator}
            showGrammarRulesGenerator={showGrammarRulesGenerator}
            abcdInput={abcdInput}
            setABCDInput={setABCDInput}
            abcdLevel={abcdLevel}
            setABCDLevel={setABCDLevel}
            abcdQuestionCount={abcdQuestionCount}
            setABCDQuestionCount={setABCDQuestionCount}
            abcdLoading={abcdLoading}
            handleABCDGenerate={handleABCDGenerate}
            handleABCDInsert={handleABCDInsert}
            handleABCDCancel={handleABCDCancel}
          />

          <OpenQuestionsGeneratorPanel
            showOpenQuestionsGenerator={showOpenQuestionsGenerator}
            generatedOpenQuestions={generatedOpenQuestions}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showABCDGenerator={showABCDGenerator}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            showMatchingHalvesGenerator={showMatchingHalvesGenerator}
            showErrorCorrectionGenerator={showErrorCorrectionGenerator}
            showGrammarRulesGenerator={showGrammarRulesGenerator}
            showJumbledSentenceGenerator={showJumbledSentenceGenerator}
            showMultipleChoiceGenerator={showMultipleChoiceGenerator}
            openQuestionsInput={openQuestionsInput}
            setOpenQuestionsInput={setOpenQuestionsInput}
            openQuestionsLevel={openQuestionsLevel}
            setOpenQuestionsLevel={setOpenQuestionsLevel}
            openQuestionsCount={openQuestionsCount}
            setOpenQuestionsCount={setOpenQuestionsCount}
            openQuestionsLoading={openQuestionsLoading}
            handleOpenQuestionsGenerate={handleOpenQuestionsGenerate}
            handleOpenQuestionsInsert={handleOpenQuestionsInsert}
            handleOpenQuestionsCancel={handleOpenQuestionsCancel}
          />

          <WordDefinitionGeneratorPanel
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            generatedWordDefinitions={generatedWordDefinitions}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            showMatchingHalvesGenerator={showMatchingHalvesGenerator}
            showErrorCorrectionGenerator={showErrorCorrectionGenerator}
            showGrammarRulesGenerator={showGrammarRulesGenerator}
            wordDefinitionInput={wordDefinitionInput}
            setWordDefinitionInput={setWordDefinitionInput}
            wordDefinitionLevel={wordDefinitionLevel}
            setWordDefinitionLevel={setWordDefinitionLevel}
            wordDefinitionLoading={wordDefinitionLoading}
            handleWordDefinitionGenerate={handleWordDefinitionGenerate}
            handleWordDefinitionInsert={handleWordDefinitionInsert}
            handleWordDefinitionCancel={handleWordDefinitionCancel}
          />

          <WordTranslationGeneratorPanel
            showWordTranslationGenerator={showWordTranslationGenerator}
            generatedWordTranslations={generatedWordTranslations}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            showMatchingHalvesGenerator={showMatchingHalvesGenerator}
            showErrorCorrectionGenerator={showErrorCorrectionGenerator}
            showGrammarRulesGenerator={showGrammarRulesGenerator}
            wordTranslationInput={wordTranslationInput}
            setWordTranslationInput={setWordTranslationInput}
            wordTranslationTargetLanguage={wordTranslationTargetLanguage}
            setWordTranslationTargetLanguage={setWordTranslationTargetLanguage}
            wordTranslationLoading={wordTranslationLoading}
            handleWordTranslationGenerate={handleWordTranslationGenerate}
            handleWordTranslationInsert={handleWordTranslationInsert}
            handleWordTranslationCancel={handleWordTranslationCancel}
          />

          <FillInTheGapsGeneratorPanel
            showFillInTheGapsGenerator={showFillInTheGapsGenerator}
            generatedFillInTheGaps={generatedFillInTheGaps}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            showMatchingHalvesGenerator={showMatchingHalvesGenerator}
            showErrorCorrectionGenerator={showErrorCorrectionGenerator}
            showGrammarRulesGenerator={showGrammarRulesGenerator}
            fillInTheGapsMode={fillInTheGapsMode}
            setFillInTheGapsMode={setFillInTheGapsMode}
            fillInTheGapsInput={fillInTheGapsInput}
            setFillInTheGapsInput={setFillInTheGapsInput}
            fillInTheGapsLevel={fillInTheGapsLevel}
            setFillInTheGapsLevel={setFillInTheGapsLevel}
            fillInTheGapsLoading={fillInTheGapsLoading}
            fillInTheGapsCustomText={fillInTheGapsCustomText}
            setFillInTheGapsCustomText={setFillInTheGapsCustomText}
            setGeneratedFillInTheGaps={setGeneratedFillInTheGaps}
            fitgTextareaRef={fitgTextareaRef}
            handleMarkGapInText={handleMarkGapInText}
            handleFillInTheGapsGenerate={handleFillInTheGapsGenerate}
            handleFillInTheGapsInsertCustom={handleFillInTheGapsInsertCustom}
            handleFillInTheGapsInsert={handleFillInTheGapsInsert}
            handleFillInTheGapsCancel={handleFillInTheGapsCancel}
          />

          <TrueFalseGeneratorPanel
            showTrueFalseGenerator={showTrueFalseGenerator}
            generatedTrueFalse={generatedTrueFalse}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            showGrammarRulesGenerator={showGrammarRulesGenerator}
            trueFalseInput={trueFalseInput}
            setTrueFalseInput={setTrueFalseInput}
            trueFalseLevel={trueFalseLevel}
            setTrueFalseLevel={setTrueFalseLevel}
            trueFalseCount={trueFalseCount}
            setTrueFalseCount={setTrueFalseCount}
            trueFalseLoading={trueFalseLoading}
            handleTrueFalseGenerate={handleTrueFalseGenerate}
            handleTrueFalseInsert={handleTrueFalseInsert}
            handleTrueFalseCancel={handleTrueFalseCancel}
          />


          <WarmUpDiscussionGeneratorPanel
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            generatedWarmUpDiscussion={generatedWarmUpDiscussion}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            showGrammarRulesGenerator={showGrammarRulesGenerator}
            warmUpDiscussionInput={warmUpDiscussionInput}
            setWarmUpDiscussionInput={setWarmUpDiscussionInput}
            warmUpDiscussionLevel={warmUpDiscussionLevel}
            setWarmUpDiscussionLevel={setWarmUpDiscussionLevel}
            warmUpDiscussionCount={warmUpDiscussionCount}
            setWarmUpDiscussionCount={setWarmUpDiscussionCount}
            warmUpDiscussionLoading={warmUpDiscussionLoading}
            handleWarmUpDiscussionGenerate={handleWarmUpDiscussionGenerate}
            handleWarmUpDiscussionInsert={handleWarmUpDiscussionInsert}
            handleWarmUpDiscussionCancel={handleWarmUpDiscussionCancel}
          />


          <CreateDialogueGeneratorPanel
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            generatedCreateDialogue={generatedCreateDialogue}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            showGrammarRulesGenerator={showGrammarRulesGenerator}
            createDialogueInput={createDialogueInput}
            setCreateDialogueInput={setCreateDialogueInput}
            createDialogueLevel={createDialogueLevel}
            setCreateDialogueLevel={setCreateDialogueLevel}
            createDialogueSpeakers={createDialogueSpeakers}
            setCreateDialogueSpeakers={setCreateDialogueSpeakers}
            createDialogueLoading={createDialogueLoading}
            handleCreateDialogueGenerate={handleCreateDialogueGenerate}
            handleCreateDialogueInsert={handleCreateDialogueInsert}
            handleCreateDialogueCancel={handleCreateDialogueCancel}
          />


          <EssentialVocabularyGeneratorPanel
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            generatedEssentialVocabulary={generatedEssentialVocabulary}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            showGrammarRulesGenerator={showGrammarRulesGenerator}
            essentialVocabularyMode={essentialVocabularyMode}
            setEssentialVocabularyMode={setEssentialVocabularyMode}
            essentialVocabularyInput={essentialVocabularyInput}
            setEssentialVocabularyInput={setEssentialVocabularyInput}
            essentialVocabularyLevel={essentialVocabularyLevel}
            setEssentialVocabularyLevel={setEssentialVocabularyLevel}
            essentialVocabularyPartOfSpeech={essentialVocabularyPartOfSpeech}
            setEssentialVocabularyPartOfSpeech={setEssentialVocabularyPartOfSpeech}
            essentialVocabularyTranslationLanguage={essentialVocabularyTranslationLanguage}
            setEssentialVocabularyTranslationLanguage={setEssentialVocabularyTranslationLanguage}
            essentialVocabularyLoading={essentialVocabularyLoading}
            handleEssentialVocabularyGenerate={handleEssentialVocabularyGenerate}
            handleEssentialVocabularyInsert={handleEssentialVocabularyInsert}
            handleEssentialVocabularyCancel={handleEssentialVocabularyCancel}
          />


          <LeadInActivitiesGeneratorPanel
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            generatedLeadInActivities={generatedLeadInActivities}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            showGrammarRulesGenerator={showGrammarRulesGenerator}
            leadInActivitiesInput={leadInActivitiesInput}
            setLeadInActivitiesInput={setLeadInActivitiesInput}
            leadInActivitiesLevel={leadInActivitiesLevel}
            setLeadInActivitiesLevel={setLeadInActivitiesLevel}
            leadInActivitiesLoading={leadInActivitiesLoading}
            handleScrollInDropdown={handleScrollInDropdown}
            handleLeadInActivitiesGenerate={handleLeadInActivitiesGenerate}
            handleLeadInActivitiesInsert={handleLeadInActivitiesInsert}
            handleLeadInActivitiesCancel={handleLeadInActivitiesCancel}
          />


          <CommunicativeSituationsGeneratorPanel
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            generatedCommunicativeSituations={generatedCommunicativeSituations}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            communicativeSituationsVocab={communicativeSituationsVocab}
            setCommunicativeSituationsVocab={setCommunicativeSituationsVocab}
            communicativeSituationsTopic={communicativeSituationsTopic}
            setCommunicativeSituationsTopic={setCommunicativeSituationsTopic}
            communicativeSituationsLevel={communicativeSituationsLevel}
            setCommunicativeSituationsLevel={setCommunicativeSituationsLevel}
            communicativeSituationsLoading={communicativeSituationsLoading}
            handleScrollInDropdown={handleScrollInDropdown}
            handleCommunicativeSituationsGenerate={handleCommunicativeSituationsGenerate}
            handleCommunicativeSituationsInsert={handleCommunicativeSituationsInsert}
            handleCommunicativeSituationsCancel={handleCommunicativeSituationsCancel}
          />


          <FourOpinionsGeneratorPanel
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            generatedFourOpinions={generatedFourOpinions}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            fourOpinionsInput={fourOpinionsInput}
            setFourOpinionsInput={setFourOpinionsInput}
            fourOpinionsLevel={fourOpinionsLevel}
            setFourOpinionsLevel={setFourOpinionsLevel}
            fourOpinionsCount={fourOpinionsCount}
            setFourOpinionsCount={setFourOpinionsCount}
            fourOpinionsLoading={fourOpinionsLoading}
            handleScrollInDropdown={handleScrollInDropdown}
            handleFourOpinionsGenerate={handleFourOpinionsGenerate}
            handleFourOpinionsInsert={handleFourOpinionsInsert}
            handleFourOpinionsCancel={handleFourOpinionsCancel}
          />


          <ProsConsGeneratorPanel
            showProsConsGenerator={showProsConsGenerator}
            generatedProsCons={generatedProsCons}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showQuizGenerator={showQuizGenerator}
            showABCDGenerator={showABCDGenerator}
            showOpenQuestionsGenerator={showOpenQuestionsGenerator}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showFillInTheGapsGenerator={showFillInTheGapsGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            prosConsInput={prosConsInput}
            setProsConsInput={setProsConsInput}
            prosConsLevel={prosConsLevel}
            setProsConsLevel={setProsConsLevel}
            prosConsPairs={prosConsPairs}
            setProsConsPairs={setProsConsPairs}
            prosConsLoading={prosConsLoading}
            setShowProsConsGenerator={setShowProsConsGenerator}
            setGeneratedProsCons={setGeneratedProsCons}
            setSelectedTemplate={setSelectedTemplate}
            handleProsConsGenerate={handleProsConsGenerate}
            handleProsConsInsert={handleProsConsInsert}
          />


          <MatchingHalvesGeneratorPanel
            showMatchingHalvesGenerator={showMatchingHalvesGenerator}
            generatedMatchingHalves={generatedMatchingHalves}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            matchingHalvesInput={matchingHalvesInput}
            setMatchingHalvesInput={setMatchingHalvesInput}
            matchingHalvesLevel={matchingHalvesLevel}
            setMatchingHalvesLevel={setMatchingHalvesLevel}
            matchingHalvesMode={matchingHalvesMode}
            setMatchingHalvesMode={setMatchingHalvesMode}
            matchingHalvesLoading={matchingHalvesLoading}
            handleMatchingHalvesGenerate={handleMatchingHalvesGenerate}
            handleMatchingHalvesInsert={handleMatchingHalvesInsert}
            handleMatchingHalvesCancel={handleMatchingHalvesCancel}
          />


          <ErrorCorrectionGeneratorPanel
            showErrorCorrectionGenerator={showErrorCorrectionGenerator}
            generatedErrorCorrection={generatedErrorCorrection}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            showMatchingHalvesGenerator={showMatchingHalvesGenerator}
            showGrammarRulesGenerator={showGrammarRulesGenerator}
            errorCorrectionInput={errorCorrectionInput}
            setErrorCorrectionInput={setErrorCorrectionInput}
            errorCorrectionLevel={errorCorrectionLevel}
            setErrorCorrectionLevel={setErrorCorrectionLevel}
            errorCorrectionSentenceCount={errorCorrectionSentenceCount}
            setErrorCorrectionSentenceCount={setErrorCorrectionSentenceCount}
            errorCorrectionLoading={errorCorrectionLoading}
            handleErrorCorrectionGenerate={handleErrorCorrectionGenerate}
            handleErrorCorrectionInsert={handleErrorCorrectionInsert}
            handleErrorCorrectionCancel={handleErrorCorrectionCancel}
          />


          <GrammarRulesGeneratorPanel
            showGrammarRulesGenerator={showGrammarRulesGenerator}
            generatedGrammarRules={generatedGrammarRules}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            showMatchingHalvesGenerator={showMatchingHalvesGenerator}
            showErrorCorrectionGenerator={showErrorCorrectionGenerator}
            grammarRulesInput={grammarRulesInput}
            setGrammarRulesInput={setGrammarRulesInput}
            grammarRulesLevel={grammarRulesLevel}
            setGrammarRulesLevel={setGrammarRulesLevel}
            grammarRulesLanguage={grammarRulesLanguage}
            setGrammarRulesLanguage={setGrammarRulesLanguage}
            grammarRulesLoading={grammarRulesLoading}
            handleGrammarRulesGenerate={handleGrammarRulesGenerate}
            handleGrammarRulesInsert={handleGrammarRulesInsert}
            handleGrammarRulesCancel={handleGrammarRulesCancel}
          />


          <JumbledSentenceGeneratorPanel
            showJumbledSentenceGenerator={showJumbledSentenceGenerator}
            generatedJumbledSentence={generatedJumbledSentence}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            showMatchingHalvesGenerator={showMatchingHalvesGenerator}
            showErrorCorrectionGenerator={showErrorCorrectionGenerator}
            showGrammarRulesGenerator={showGrammarRulesGenerator}
            jumbledSentenceMode={jumbledSentenceMode}
            setJumbledSentenceMode={setJumbledSentenceMode}
            jumbledSentenceInput={jumbledSentenceInput}
            setJumbledSentenceInput={setJumbledSentenceInput}
            jumbledSentenceLevel={jumbledSentenceLevel}
            setJumbledSentenceLevel={setJumbledSentenceLevel}
            jumbledSentenceCount={jumbledSentenceCount}
            setJumbledSentenceCount={setJumbledSentenceCount}
            jumbledSentenceLoading={jumbledSentenceLoading}
            setGeneratedJumbledSentence={setGeneratedJumbledSentence}
            handleJumbledSentenceGenerate={handleJumbledSentenceGenerate}
            handleJumbledSentenceInsert={handleJumbledSentenceInsert}
            handleJumbledSentenceCancel={handleJumbledSentenceCancel}
          />


          <MultipleChoiceGeneratorPanel
            showMultipleChoiceGenerator={showMultipleChoiceGenerator}
            generatedMultipleChoice={generatedMultipleChoice}
            showAskMe={showAskMe}
            showTemplates={showTemplates}
            showWordDefinitionGenerator={showWordDefinitionGenerator}
            showWordTranslationGenerator={showWordTranslationGenerator}
            showTrueFalseGenerator={showTrueFalseGenerator}
            showWarmUpDiscussionGenerator={showWarmUpDiscussionGenerator}
            showCreateDialogueGenerator={showCreateDialogueGenerator}
            showEssentialVocabularyGenerator={showEssentialVocabularyGenerator}
            showLeadInActivitiesGenerator={showLeadInActivitiesGenerator}
            showFourOpinionsGenerator={showFourOpinionsGenerator}
            showCommunicativeSituationsGenerator={showCommunicativeSituationsGenerator}
            showMatchingHalvesGenerator={showMatchingHalvesGenerator}
            showErrorCorrectionGenerator={showErrorCorrectionGenerator}
            showGrammarRulesGenerator={showGrammarRulesGenerator}
            showJumbledSentenceGenerator={showJumbledSentenceGenerator}
            multipleChoiceMode={multipleChoiceMode}
            setMultipleChoiceMode={setMultipleChoiceMode}
            multipleChoiceInput={multipleChoiceInput}
            setMultipleChoiceInput={setMultipleChoiceInput}
            multipleChoiceLevel={multipleChoiceLevel}
            setMultipleChoiceLevel={setMultipleChoiceLevel}
            multipleChoiceCount={multipleChoiceCount}
            setMultipleChoiceCount={setMultipleChoiceCount}
            multipleChoiceOptionCount={multipleChoiceOptionCount}
            setMultipleChoiceOptionCount={setMultipleChoiceOptionCount}
            multipleChoiceLoading={multipleChoiceLoading}
            setGeneratedMultipleChoice={setGeneratedMultipleChoice}
            handleMultipleChoiceGenerate={handleMultipleChoiceGenerate}
            handleMultipleChoiceInsert={handleMultipleChoiceInsert}
            handleMultipleChoiceCancel={handleMultipleChoiceCancel}
          />


          {showTemplates && !selectedTemplate && !exerciseResult && !showAskMe && !showQuizGenerator && !showABCDGenerator && !showOpenQuestionsGenerator && !showWordDefinitionGenerator && !showFillInTheGapsGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showEssentialVocabularyGenerator && !showLeadInActivitiesGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator && !showMatchingHalvesGenerator && !showErrorCorrectionGenerator && !showGrammarRulesGenerator && !showJumbledSentenceGenerator && !showMultipleChoiceGenerator && (
            <>
              <button
                style={{ fontSize: 15, fontWeight: 400, color: '#8a2be2', background: 'none', border: 'none', borderRadius: 8, padding: '5px 10px', cursor: 'pointer', width: '100%', textAlign: 'left', display: 'flex', alignItems: 'center', marginBottom: 5, marginTop: 5 }}
                onClick={() => { setShowTemplates(false); setShowAskMe(false); setSelectedTemplate(null); setExerciseResult(""); setShowErrorCorrectionGenerator(false); setShowGrammarRulesGenerator(false); }}
              >
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" style={{marginRight:8,verticalAlign:'middle'}}><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                <span style={{ position: 'relative', top: '2px' }}>Return</span>
              </button>
              <div 
                className="templates-scroll"
                style={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  gap: 0,
                  maxHeight: '300px',
                  overflowY: 'auto',
                  scrollBehavior: 'auto',
                  paddingRight: '12px',
                  marginRight: '4px',
                  scrollbarWidth: 'thin',
                  scrollbarColor: 'rgba(156, 163, 175, 0.3) transparent'
                }}
                onWheel={handleScrollInDropdown}
              >
                {/* Tag filter bar */}
                <div
                  className="tags-scroll"
                  style={{
                    display: 'flex',
                    gap: 8,
                    padding: '12px 16px',
                    position: 'sticky',
                    top: 0,
                    background: '#fff',
                    zIndex: 1,
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    whiteSpace: 'nowrap',
                    scrollbarWidth: 'none', // Firefox
                    msOverflowStyle: 'none', // IE/Edge
                    minHeight: '48px',
                    alignItems: 'center'
                  }}
                  onWheel={(e) => {
                    // horizontal scroll for tags only; prevent parent list scroll
                    const el = e.currentTarget;
                    const maxScroll = el.scrollWidth - el.clientWidth;
                    
                    if (maxScroll <= 0) {
                      // если контент помещается, не блокируем событие
                      return;
                    }
                    
                    // Используем нативное поведение, но с горизонтальной прокруткой
                    const deltaX = e.deltaY; // используем deltaY для горизонтальной прокрутки
                    el.scrollLeft += deltaX;
                    
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  {['#all', '#reading', '#vocabulary', '#speaking', '#grammar', '#game'].map(tag => (
                    <button
                      key={tag}
                      onClick={(e) => { e.stopPropagation(); setTemplateTagFilter(tag); }}
                      style={{
                        fontSize: 13,
                        padding: '6px 12px',
                        borderRadius: 999,
                        border: '0.5px solid',
                        borderColor: tag === '#reading' ? '#fde68a' : tag === '#vocabulary' ? '#93c5fd' : tag === '#speaking' ? '#6ee7b7' : tag === '#grammar' ? '#e9d5ff' : tag === '#game' ? '#fda4af' : '#d1d5db',
                        color: templateTagFilter === tag ? '#111827' : '#6b7280',
                        background: tag === '#reading' ? '#fef3c7' : tag === '#vocabulary' ? '#dbeafe' : tag === '#speaking' ? '#d1fae5' : tag === '#grammar' ? '#f3e8ff' : tag === '#game' ? '#ffe4e6' : '#f3f4f6',
                        fontWeight: 600,
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        flexShrink: 0
                      }}
                    >{tag}</button>
                  ))}
                </div>

                {TEMPLATES.filter(tpl => {
                  if (templateTagFilter === '#all') return true;
                  const list = tpl.tags && Array.isArray(tpl.tags) ? tpl.tags : (tpl.tag ? [tpl.tag] : []);
                  return list.includes(templateTagFilter);
                }).map((tpl, i, arr) => (
                  <button
                    key={tpl.label}
                    style={{ fontSize: 15, fontWeight: 400, color: '#111827', background: '#fff', border: 'none', borderRadius: 8, padding: '10px 0', paddingLeft: 18, cursor: 'pointer', width: '100%', textAlign: 'left', transition: 'background 0.18s, color 0.18s', marginBottom: i === (arr.length - 1) ? 0 : 2, display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'space-between' }}
                    onMouseEnter={e => { e.currentTarget.style.background = '#f3f4f6'; e.currentTarget.style.color = '#8a2be2'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#111827'; }}
                    onClick={() => handleTemplateSelect(tpl)}
                  >
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      {tpl.icon && <span style={{ color: 'currentColor' }}>{tpl.icon}</span>}
                      {tpl.label}
                    </span>
                    {tpl.tags && Array.isArray(tpl.tags) && tpl.tags.length > 0 ? (
                      <span style={{ display: 'flex', gap: 6 }}>
                        {tpl.tags.map(tag => (
                          <span key={tag} style={{ 
                            fontSize: 12, 
                            color: tag === '#vocabulary' ? '#2563eb' : tag === '#speaking' ? '#047857' : tag === '#grammar' ? '#9333ea' : tag === '#reading' ? '#92400e' : tag === '#game' ? '#9f1239' : '#6b7280', 
                            background: tag === '#vocabulary' ? '#dbeafe' : tag === '#speaking' ? '#d1fae5' : tag === '#grammar' ? '#f3e8ff' : tag === '#reading' ? '#fef3c7' : tag === '#game' ? '#ffe4e6' : '#f3f4f6', 
                            border: '0.5px solid',
                            borderColor: tag === '#vocabulary' ? '#93c5fd' : tag === '#speaking' ? '#6ee7b7' : tag === '#grammar' ? '#e9d5ff' : tag === '#reading' ? '#fde68a' : tag === '#game' ? '#fda4af' : '#e5e7eb', 
                            padding: '2px 8px', 
                            borderRadius: 999, 
                            whiteSpace: 'nowrap' 
                          }}>{tag}</span>
                        ))}
                      </span>
                    ) : tpl.tag ? (
                      <span style={{ 
                        fontSize: 12, 
                        color: tpl.tag === '#vocabulary' ? '#2563eb' : tpl.tag === '#speaking' ? '#047857' : tpl.tag === '#grammar' ? '#9333ea' : tpl.tag === '#reading' ? '#92400e' : tpl.tag === '#game' ? '#9f1239' : '#6b7280', 
                        background: tpl.tag === '#vocabulary' ? '#dbeafe' : tpl.tag === '#speaking' ? '#d1fae5' : tpl.tag === '#grammar' ? '#f3e8ff' : tpl.tag === '#reading' ? '#fef3c7' : tpl.tag === '#game' ? '#ffe4e6' : '#f3f4f6', 
                        border: '0.5px solid',
                        borderColor: tpl.tag === '#vocabulary' ? '#93c5fd' : tpl.tag === '#speaking' ? '#6ee7b7' : tpl.tag === '#grammar' ? '#e9d5ff' : tpl.tag === '#reading' ? '#fde68a' : tpl.tag === '#game' ? '#fda4af' : '#e5e7eb', 
                        padding: '2px 8px', 
                        borderRadius: 999, 
                        whiteSpace: 'nowrap' 
                      }}>{tpl.tag}</span>
                    ) : null}
                  </button>
                ))}
              </div>
            </>
          )}

          {selectedTemplate && !exerciseResult && !showAskMe && !showQuizGenerator && !showABCDGenerator && !showOpenQuestionsGenerator && !showWordDefinitionGenerator && !showFillInTheGapsGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showEssentialVocabularyGenerator && !showLeadInActivitiesGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator && !showMatchingHalvesGenerator && !showErrorCorrectionGenerator && !showGrammarRulesGenerator && !showJumbledSentenceGenerator && !showMultipleChoiceGenerator && (
            <></>
          )}

          {exerciseResult && !showAskMe && !showQuizGenerator && !showABCDGenerator && !showOpenQuestionsGenerator && !showWordDefinitionGenerator && !showFillInTheGapsGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showEssentialVocabularyGenerator && !showLeadInActivitiesGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator && !showMatchingHalvesGenerator && !showErrorCorrectionGenerator && !showGrammarRulesGenerator && !showJumbledSentenceGenerator && !showMultipleChoiceGenerator && (
            <>
              <textarea value={exerciseResult} readOnly rows={6} style={{ fontSize: 15, padding: 8, borderRadius: 8, border: '1.5px solid #cfcfff', background: '#f7fbff', resize: 'vertical', marginBottom: 8, fontFamily: 'Inter, Segoe UI, Arial, sans-serif' }} />
              <button
                style={{ fontSize: 15, padding: '8px 16px', borderRadius: 8, border: 'none', background: '#8a2be2', color: '#fff', fontWeight: 600, cursor: 'pointer' }}
                onClick={() => { if (activeEditor) activeEditor.chain().focus().insertContent(exerciseResult).run(); }}
              >Add to Editor</button>
            </>
          )}

    </>
  );
}
